import { RatioProgressBar, RatioProgressBarProps } from '@cast/design-system';

export const RatioProgressBarWithLoading = ({
  isLoading,
  ...restProps
}: RatioProgressBarProps & { isLoading: boolean }) => {
  const finalProps: RatioProgressBarProps = isLoading
    ? {
        ...restProps,
        bars: [],
        total: 100,
      }
    : { ...restProps };

  return <RatioProgressBar {...finalProps} />;
};
